import React from 'react';

// [B14-A] İki net mod: Günlük (make-now, alışveriş yok) ve Haftalık (plan + otomatik liste).
// 3-günlük kaldırıldı (ortada kalan, alışveriş listesi anlamsız küçük).
const OPTIONS = [
  { value: 'today', label: 'Günlük', description: 'Bugün stoğundan öneriler' },
  { value: '7d', label: 'Haftalık', description: 'Plan + otomatik alışveriş listesi' }
];

export default function PlanningHorizonToggle({
  value = 'today',
  onChange,
  mode = 'diet',
  className = ''
}) {
  const helperText = mode === 'athlete'
    ? 'Antrenman durumun ve performans hedeflerin dikkate alinarak onerildi.'
    : 'Kalori ve makro hedeflerine en yakın seçenekler öne çıkarıldı.';

  return (
    <section className={`rounded-[2rem] border border-slate-200 bg-white/95 p-4 shadow-sm dark:border-slate-700 dark:bg-slate-800/90 ${className}`}>
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-[11px] font-black uppercase tracking-[0.18em] text-slate-400">Plan Gorunumu</p>
          <p className="mt-1 text-sm font-semibold text-slate-700 dark:text-slate-200">
            Önce tarifleri gör, istersen planı genişletelim.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-2 rounded-2xl bg-slate-100 p-1 dark:bg-slate-900/70">
          {OPTIONS.map((option) => {
            const active = value === option.value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => onChange?.(option.value)}
                className={`rounded-xl px-3 py-2 text-left transition-all ${active
                  ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-500/20'
                  : 'text-slate-600 hover:bg-white dark:text-slate-300 dark:hover:bg-slate-800'
                  }`}
              >
                <div className="text-[11px] font-black uppercase tracking-[0.15em]">{option.label}</div>
                <div className={`mt-1 text-[10px] font-medium leading-tight ${active ? 'text-white/80' : 'text-slate-400'}`}>
                  {option.description}
                </div>
              </button>
            );
          })}
        </div>
      </div>
      <p className="mt-3 text-[11px] font-medium text-slate-500 dark:text-slate-400">{helperText}</p>
    </section>
  );
}
